export default __webpack_public_path__ + "static/media/egg-step3.448fba77.jpg";